let config = {
  "production": {
    "host": "https://healthrisk.docsapp.in/hraapp",
    "healthData_url": "https://healthrisk.docsapp.in/hraapp/healthData"
  },
  "development": {
    "host": "http://localhost:3074",
    "healthData_url": "http://localhost:3074/healthData"
  }
}

export default config[process.env.NODE_ENV];